import React, { createRef, RefObject, ReactNode, useContext } from 'react';
import { Layout } from '../Layout';
import { IntlShape, useIntl } from 'react-intl';
import { faCaretLeft } from '@fortawesome/free-solid-svg-icons/faCaretLeft';
import { InternalLink } from '../components/InternalLink';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { VoidApiResponse } from '../../api/core';
import { getAuthMiddleware } from '../../Auth/utils/GetAuthMiddleware';
import { AuthContext } from '../../Auth/components/AuthProvider';
import { ToastContext, ToastContextType } from '../../util/providers/ToastProvider';
import { FileUpload, FileUploadHandlerEvent } from 'primereact/fileupload';
import { maxFileSize } from '../../Settings/config';
import { SubmissionServiceApi } from '../../api/submission';

export const UploadPage = (): ReactNode => {
  const toast: ToastContextType = useContext(ToastContext);
  const {actions} = useContext(AuthContext);
  const api: SubmissionServiceApi = new SubmissionServiceApi().withMiddleware(getAuthMiddleware(actions));
  const intl: IntlShape = useIntl();
  const upload: RefObject<FileUpload> = createRef<FileUpload>();

  const submit = (event: FileUploadHandlerEvent): void => {
    api.uploadFileRaw({file: event.files[0]})
      .then((response: VoidApiResponse): void => {
        if(response.raw.status === 201) {
          upload.current.clear();
          return toast.notify({
            summary: intl.formatMessage({id: 'message.upload.success.title'}),
            detail: intl.formatMessage({id: 'message.upload.success.message'}),
            severity: 'success'
          });
        }
        toast.error(response);
      })
      .catch(error => {
        toast.error(error);
      });
  };

  return (
    <Layout
      title={intl.formatMessage({id: 'work.upload.headline'})}
    >
      <div className={'flex flex-column px-3  gap-4'}>
        <div>
          <InternalLink to={'/work/add'} internalIcon={false}>
            <FontAwesomeIcon icon={faCaretLeft}/>&nbsp;{intl.formatMessage({id: 'button.back'})}
          </InternalLink>
        </div>
        <div>
          <p dangerouslySetInnerHTML={{__html: intl.formatMessage({id: 'work.upload.description'})}}/>
          <p
            dangerouslySetInnerHTML={{__html: intl.formatMessage({id: 'work.upload.dropzone.maxFileSize'}, {size: '16 MB'})}}/>
        </div>
        <FileUpload
          ref={upload}
          multiple={false}
          maxFileSize={maxFileSize}
          customUpload={true}
          chooseLabel={intl.formatMessage({id: 'button.choose'})}
          uploadLabel={intl.formatMessage({id: 'button.upload'})}
          cancelLabel={intl.formatMessage({id: 'button.abort'})}
          uploadHandler={submit}
        />
      </div>
    </Layout>
  );
};

export default UploadPage;
